module.exports = __webpack_public_path__ + "img/86.5b9adcd8.jpg";